var escape = require("../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container{\r\n  text-align: center;\r\n  background-image: url(" + escape(require("../../assets/img/mapa1.png")) + ");\r\n\r\n}\r\n\r\n#login{\r\n  background-color: rgba(205, 205, 205, 0.6);\r\n  border-radius: 8px;\r\n}\r\n\r\na{\r\n  color: #f5710d;\r\n}\r\n\r\n.btn-primary{\r\n  border-color: #f5710d;\r\n  background-color: #f5710d;\r\n}\r\n\r\n.btn-primary:active, .btn-primary:visited, .btn-primary:focus {\r\n  background-color: #d77816 !important;\r\n  border-color: #e08c36 !important;\r\n}\r\n\r\n.logo{\r\n  padding-top: 5%;\r\n}\r\n\r\n.custom-control-label::before{\r\n  top: .3rem;\r\n  width: 1.5rem;\r\n  height: 1.5rem;\r\n  background-color: rgba(#383838, 0.69) !important;\r\n  border-style: solid;\r\n  border-color: #383838;\r\n}\r\n\r\n.custom-control-label::after {\r\ntop: .3rem;\r\nwidth: 1.5rem;\r\nheight: 1.5rem;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/CLAUDIA/Desktop/Timeplacebook2/src/app/login/login.component.css
// module id = ../../../../../src/app/login/login.component.css
// module chunks = main